<template>
  <router-view />
  <login-dialog :popupShow="loginShow" v-if="loginShow" @close="closeLogin"></login-dialog>
</template>
<script lang="ts" setup>
import { ref, reactive, onMounted, computed, watch } from 'vue';
import { useStore } from "vuex"
import { useRoute } from 'vue-router';
import LoginDialog from '@/layout/components/loginDialog.vue'; // @ is an alias to /src
import { getConfigByCode } from "@/api/common.js"
const loginShow = ref(false)
const store = useStore();
const route = useRoute()
const state = reactive({
  loginFlag: store.state.loginFlag
})
watch(() => store.state.loginFlag, (newVal) => {
  if (newVal) {
    loginShow.value = true;
    state.loginFlag = newVal;
  }
})
watch(() => route.path, (newVal) => {
  if (newVal && newVal == 'paySuccess') {
    loginShow.value = false;
  }
})
function closeLogin() {
  loginShow.value = false
}
</script>


<style lang="scss">
html,
body {
  padding: 0;
  margin: 0;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
